import React from 'react';
import { X } from 'lucide-react';
import { LeafDivider, Section } from './Shared';
import { HerbSprig, LeafCluster } from './HealingIcons';
export const PainPoints = () => {
  const points = ['Llegar a la consulta sin saber exactamente qué planta indicar para el cuadro que tienes enfrente.', 'Dudar entre varias hierbas porque no tienes una ficha técnica clara que te respalde.', 'No saber qué preparación hacer con esa planta: infusión, tintura, ungüento o decocción.', 'No conocer las contraindicaciones exactas antes de recomendar a una paciente embarazada o medicada.', 'Sin protocolo de seguridad ante interacciones planta-fármaco.', 'Sin recetario de fórmulas concretas: armando cada combinación desde cero en cada consulta.', 'Sin ficha clínica profesional: cada consulta sin registro ni continuidad.', 'Sin saber de dónde proviene tu materia prima ni cómo evaluarla.', 'Pacientes que no vuelven porque no perciben resultados concretos.', 'Cada sesión comienzas de cero, sin estructura real ni respaldo clínico.'];
  return <Section className="max-w-4xl relative" data-id="element-323" data-mp="1yzdm4jp9m7lh">
      <HerbSprig className="hidden lg:block absolute top-10 left-[1%] w-10 h-10 opacity-25 animate-float-soft" color="#6FA524" style={{
      transform: 'rotate(-12deg)'
    }} data-id="element-324" data-mp="1u1lkuz2qd94m" />
      <LeafCluster className="hidden lg:block absolute bottom-24 right-[2%] w-12 h-12 opacity-25 animate-float-soft" color="#C9A961" style={{
      animationDelay: '1.4s'
    }} data-id="element-325" data-mp="27v32uffrqdsj" />
      <div className="text-center mb-12" data-id="element-326" data-mp="1g2cf6tc5hxew">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-purpleDark" data-id="element-327" data-mp="1b2zjdj3axg06">
          ¿Cuántas consultas más vas a trabajar sin un sistema clínico sólido?
        </h2>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-328" data-mp="1k2wdi08gn72m">
          Eres terapeuta natural. Amas lo que haces. Crees en el poder de las
          plantas medicinales. Pero nadie te dijo que ibas a llegar a la
          consulta sin saber exactamente qué planta indicar, en qué dosis, con
          qué precauciones y para qué cuadro específico.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-329" data-mp="1y3zrz675ueeh">
          No es falta de vocación. No es falta de experiencia. Es falta de un
          sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-purple/20" data-id="element-330" data-mp="2756bzp90q7ch">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-purpleDark text-base md:text-lg" data-id="element-331" data-mp="1afgkutzuk7nz">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-332" data-mp="1ehaeiibmkben" /> Lo que
          pasa sin el Megapack Saberes Ancestrales:
        </h3>
        <ul className="space-y-4" data-id="element-333" data-mp="1jd93a70v7vfl">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-334" data-mp="1o6u221aa8tfu" data-mpi={i}>
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-335" data-mp="qqocb7oaxlck" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-336" data-mp="qotyedbg6thz">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <LeafDivider data-id="element-337" data-mp="o56zilrdxwy1" />

      <div className="text-center" data-id="element-338" data-mp="o5guknraeual">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-339" data-mp="j75hm45p43o5">
          ¿Y si esta fuera la última consulta que trabajas así?
        </h3>
      </div>
    </Section>;
};